const { useState } = require('react');
const ApiService = require('../../../../services/client/address-hub');

const useUpdateCurrentLocation = (ob) => {
  const [update, setUpdate] = useState(ob);

  function updateCurrentLoaction(event) {
    const data = Object.fromEntries(new FormData(event.currentTarget));

    ApiService.updateCurrentLoaction(data)
      .then((json) => setUpdate(json))
      .catch((error) => {
        setUpdate({ errors: { exception: error } });
      });
  }
  return [update, updateCurrentLoaction];
};
module.exports = useUpdateCurrentLocation;
